import { render, staticRenderFns } from "./CreateCharacter.vue?vue&type=template&id=1aee0512"
import script from "./CreateCharacter.vue?vue&type=script&lang=js"
export * from "./CreateCharacter.vue?vue&type=script&lang=js"
import style0 from "./CreateCharacter.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports